import howToBuy from './howToBuy'
import ourWorks from './ourWorks'
import page from './page'

export default {
  modules: {
    howToBuy,
    ourWorks,
    page
  }
}
